import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Clock, CheckCircle2, XCircle, PauseCircle } from 'lucide-react';
import { Task } from '../../types';

interface TaskStatusTransitionProps {
  currentStatus: Task['status'];
  onStatusChange: (status: Task['status']) => void;
}

export const TaskStatusTransition: React.FC<TaskStatusTransitionProps> = ({
  currentStatus,
  onStatusChange,
}) => {
  const statusOptions: Array<{
    status: Task['status'];
    icon: JSX.Element;
    label: string;
    color: string;
  }> = [
    {
      status: 'pending',
      icon: <PauseCircle size={20} />,
      label: 'Pending',
      color: 'text-gray-500',
    },
    {
      status: 'in-progress',
      icon: <Clock size={20} />,
      label: 'In Progress',
      color: 'text-blue-500',
    },
    {
      status: 'completed',
      icon: <CheckCircle2 size={20} />,
      label: 'Completed',
      color: 'text-green-500',
    },
    {
      status: 'blocked',
      icon: <XCircle size={20} />,
      label: 'Blocked',
      color: 'text-red-500',
    },
  ];

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        gap: 0.5,
        p: 0.5,
      }}
    >
      {statusOptions.map((option) => {
        const isCurrentStatus = currentStatus === option.status;
        
        return (
          <Tooltip 
            key={option.status} 
            title={option.label}
            arrow
          >
            <span>
              <IconButton
                size="small"
                onClick={() => onStatusChange(option.status)}
                sx={{
                  opacity: isCurrentStatus ? 0.5 : 1,
                  '& svg': {
                    className: option.color,
                  },
                }}
                disabled={isCurrentStatus}
              >
                {option.icon}
              </IconButton>
            </span>
          </Tooltip>
        );
      })}
    </Box>
  );
};